import type { DashboardType } from '@/types/dashboard-types'

export const validateDashboardTitle = (
  title: string,
  dashboards: Pick<DashboardType, 'title' | 'slug'>[],
  ignoreSlug?: string
): string | undefined => {
  const trimmed = title.trim()
  if (!trimmed) return 'Dashboard name is required'
  if (trimmed.length < 3) return 'Dashboard name must be at least 3 characters'
  if (dashboards.some((dashboard) => dashboard.slug !== ignoreSlug && dashboard.title === trimmed)) {
    return 'A dashboard with this name already exists'
  }
  return undefined
}
